// extracted by mini-css-extract-plugin
export default {"box":"ErrorBlock_box__ymcs5","title":"ErrorBlock_title__Awrxy","link":"ErrorBlock_link__AK5e0"};